/** ****************************** Import libs *********************************** */
import {  deleteDataByIdApi, deleteMultipleDataApi} from "./action";

import { URL_CONSTANTS } from "./urls";




export const deleteRole = (dataId: string | number) =>
    deleteDataByIdApi(URL_CONSTANTS.deleteRole, dataId);

export const UsersDeleteAPI = (dataId: string | number) =>
    deleteDataByIdApi(URL_CONSTANTS.deleteUser, dataId);

export const RemoveNotesAPI = (dataId: string | number) =>
    deleteDataByIdApi(URL_CONSTANTS.updateNotesErrorList, dataId);

export const DeleteMultiplenotesAPI = (params : any) => 
    deleteMultipleDataApi(URL_CONSTANTS.multipleDeleteNotes, params);

// mapping notestype
export const MappingNotesTypeDeleteAPI = (dataId: string | number) =>
    deleteDataByIdApi(URL_CONSTANTS.getMappingNotesType, dataId);

export const CustomNotesTypeDeleteAPI = (dataId: string | number) =>
    deleteDataByIdApi(URL_CONSTANTS.customNotesType, dataId);

export const DeleteCustomNotesTypeAPI = (params : any) => 
    deleteMultipleDataApi(URL_CONSTANTS.deletecustomNotesType, params);

export const DeleteMultipleUserAPI = (params : any) => 
    deleteMultipleDataApi(URL_CONSTANTS.deleteMultipleUser, params);


export const DeleteMultipleRoleAPI = (params : any) => 
    deleteMultipleDataApi(URL_CONSTANTS.deleteMultipleRole, params);

export const RoleDeleteAPI = (dataId: string | number) =>
    deleteDataByIdApi(URL_CONSTANTS.getRoles, dataId);

export const LocationDeleteAPI = (dataId: string | number) =>
    deleteDataByIdApi(URL_CONSTANTS.getMappedLocationList, dataId);

export const MappedLocationDeleteAPI = (params : any) =>
    deleteMultipleDataApi(URL_CONSTANTS.locationMapping, params);

// patient mapping 
export const MappedPatientDeleteAPI = (params : any) =>
    deleteMultipleDataApi(URL_CONSTANTS.mappedPatient, params);

// efax
export const DeleteEfaxNumberAPI = (dataId: string | number) =>
    deleteDataByIdApi(URL_CONSTANTS.efaxCurd, dataId);

export const DeleteMultipleEfaxAPI = (params : any) =>
    deleteMultipleDataApi(URL_CONSTANTS.deleteMultipleEfax, params);

// --------------------------------- Auto Delete ---------------------
export const deleteAutoDeleteConfig = (dataId: string | number) =>
    deleteDataByIdApi(URL_CONSTANTS.autoDeleteConfigs, dataId);

